export default __webpack_public_path__ + "static/media/logo.8ef62bc2.png";